import React from "react";
import { Building2, Briefcase, LineChart, Calculator } from "lucide-react";

const audiences = [
  {
    icon: Building2,
    title: "Real Estate Investors",
    body:
      "Accelerate depreciation on new acquisitions, renovations, and existing portfolios. Free cash for your next deal.",
    bullet: "Avg. first-year deduction: 25–35% of building basis",
  },
  {
    icon: Briefcase,
    title: "Business Owners",
    body:
      "Claim the federal & state R&D Tax Credit for product development, process improvement, software, and engineering work.",
    bullet: "Avg. credit: 8–10% of qualified expenses",
  },
  {
    icon: LineChart,
    title: "Private Equity",
    body:
      "Portfolio-wide engineering studies that meaningfully lift EBITDA and after-tax IRR — without operational disruption.",
    bullet: "Portfolio-level pricing & rollouts",
  },
  {
    icon: Calculator,
    title: "CPAs & Advisors",
    body:
      "We're the engineering partner behind hundreds of firms. White-glove studies your clients can defend on audit.",
    bullet: "Audit defense & full IRS correspondence included",
  },
];

export default function WhoWeServe() {
  return (
    <section id="who-we-serve" data-testid="who-we-serve-section" className="py-24 sm:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="text-forest-600 uppercase tracking-[0.24em] text-sm mb-4">
              Who we serve
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-forest-950 leading-[1.05] tracking-tight">
              Built for the people <br />
              <span className="italic text-brass">writing the biggest checks</span> to the IRS.
            </h2>
          </div>
          <p className="lg:col-span-5 text-forest-800 text-lg leading-relaxed">
            Whether you own one rental, run a manufacturing company, or oversee
            a 40-property portfolio, the tax code rewards capital deployment.
            We make sure you're collecting every dollar of it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ivory-400 border border-ivory-400">
          {audiences.map(({ icon: Icon, title, body, bullet }) => (
            <div
              key={title}
              data-testid={`audience-card-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="bg-ivory p-10 transition-all duration-300 hover:bg-white hover:-translate-y-1 group"
            >
              <Icon className="text-brass mb-6" size={32} strokeWidth={1.5} />
              <h3 className="font-serif text-3xl text-forest-950 mb-4">{title}</h3>
              <p className="text-forest-800 leading-relaxed mb-6">{body}</p>
              <div className="pt-4 border-t border-ivory-400 text-forest-600 text-sm uppercase tracking-[0.2em]">
                {bullet}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
